window.addEventListener("DOMContentLoaded", function()
{
    var container = document.querySelector( "[data-welleasy-days-aisle]" );
    if( container )
    {
        var template = container.querySelector( "[data-myaisle-product-card-template]" );
        if( template )
        {
            template.style.display = "none";
        }
        var parent = SearchParentsFor( container, "collection_section_wrapper" );
        if( parent )
        {
            var loadingGif = parent.querySelector( ".we-section-loading-gif" );
            if( loadingGif )
            {
                loadingGif.classList.add( "hidden" );
            }
            var backdrop = parent.querySelector( ".we-backdrop-prdt" );
            if( backdrop )
            {
                backdrop.classList.remove( "hidden" );
            }
        }
    }

    var productsScript = document.querySelector( "[data-welleasy-days-products]" );
    if( productsScript )
    {
        try
        {
            var products = JSON.parse( productsScript.textContent );
            if( products.length > 0 && window._learnq )
            {
                var html = "";
                for( var p = 0; p < products.length; p++ )
                {
                    var prod = products[ p ];
                    if( p > 0 && p % 3 === 0 ) { html += '</tr><tr>'; }
                    html += '<td style="padding: 10px; vertical-align: top; width: 33%;">';
                    html += '<a href="https://welleasy.co.uk' + prod.url + '" style="text-decoration: none; color: inherit; display: block;">';
                    html += '<img src="https:' + prod.image + '" alt="" width="200" style="max-width: 100%; display: block; margin: 0 auto 8px;">';
                    html += '<p style="margin: 0 0 4px; font-weight: bold; font-size: 14px; line-height: 1.3;">' + prod.title + '</p>';
                    html += '<p style="margin: 0; font-size: 14px;">' + prod.price + '</p>';
                    html += '</a>';
                    html += '</td>';
                }
                window._learnq.push( [
                    "track",
                    "Viewed WellEasy Days Products",
                    {
                        products_count: products.length,
                        welleasy_days_products: products,
                        products_html: '<table width="100%" cellpadding="0" cellspacing="0"><tr>' + html + '</tr></table>'
                    }
                ] );
                window._learnq.push( [
                    "identify",
                    {
                        welleasy_days_products: products,
                        welleasy_days_products_count: products.length,
                        welleasy_days_products_html: '<table width="100%" cellpadding="0" cellspacing="0"><tr>' + html + '</tr></table>'
                    }
                ] );
            }
        }
        catch( e ) {}
    }
} );
